<template>
  <div data-v-60016932="" class="Setting transitionBody">
    <div data-v-60016932="" class="head_area">
      <div data-v-60016932="" class="leftImg">
        <van-icon name="arrow-left" @click="back"/>
      </div>
      <span data-v-60016932="" class="head_text">{{ $t('设置') }}</span>
      <span data-v-60016932=""
                                                                                                                                                  class="right_menu"></span>
    </div>
    <div data-v-60016932="" class="set-list">
      <div data-v-60016932="" class="set-list_item"><span data-v-60016932=""><i data-v-60016932=""
                                                                                class="person-icon position-icon1"></i>{{ $t('消息时间显示') }}</span>

        <van-switch v-model="checked" size="18px" active-color="#ff8439" inactive-color="#9ca3bf"/>
      </div>
      <div data-v-60016932="" class="set-list_item"><span data-v-60016932=""><i data-v-60016932=""
                                                                                class="person-icon position-icon2"></i>{{ $t('中奖提示') }}</span>
        <van-switch v-model="checked2" size="18px" active-color="#ff8439" inactive-color="#9ca3bf"/>
      </div>
      <div data-v-60016932="" class="set-list_item"><span data-v-60016932=""><i data-v-60016932=""
                                                                                class="person-icon position-icon2"></i>{{ $t('安静模式') }}</span>
        <van-switch v-model="checked3" size="18px" active-color="#ff8439" inactive-color="#9ca3bf"/>
      </div>
    </div>
    <div data-v-60016932="" class="set-list">
      <!--          <p data-v-60016932="" class="set-list_item"><span data-v-60016932=""><i data-v-60016932=""-->
      <!--                      class="person-icon position-icon4"></i>{{ $t('关于CG') }}</span><img data-v-60016932=""-->
      <!--                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAkCAYAAACJ8xqgAAADQUlEQVRIS52WTWgTURDH/5MNrdRaEWkRLB5EQfADQaGK1mSjRakoCBpQm4R81AhqQT140IOCXkQU9KA1aWOTViEigqIgrdnED1DwInoRehApKi0iVg22Zndk17bE9r121zm+mf+PmZ1585YAoKMnr7LBKRCYdASiIfWZef4/RolubR0xPQa4agzw3cXcFAn6Xv4XMJnR3gBYMUn8VSGXJ9ziMX2OjJIZbRBA7WQVgQYZvCEWUPudECmZzh8F8UWJaEA3ShvioaYPdqFkNSWtXWDCcYmoXymhMRxWP9uBWkBmps7uwjUGHxCJGHhTYehqKLTly0xQC2haNptVhn/VpUG8TyJ6qVeWtsb9Td+mg04AzaDTmuauH6A7AO+UiPJ68cf2eHxHUQb9BziWacXwSO1DAJvFInpYUzm4y+/3j4r8U4BmUHv7/SpldnUfGOuFUMLtmoqhvX6/X586bpLc27O9c5URdx7Aagn0RnS/N0JEXO4XZjge0Nn5pJbd+hMmLBN2n/lKa9DXZhtoBia6tXpiKgC8WJgp41wsqJ4a902b4XhQMqMtAaABqBdD+UQs6Dtv+mwBzcDrN3LLXQqZ0Cn33roboEOtAe9V20Cr/J7cGjLMVYe5gkwZjH2OgCako0vbyC56VLY/y9mfHAM707kGg6gXwBxBll8cAVPdhZU6GwUA84QlE8K2gamewlLD4GcMrhN3mo7Fgt5LtoDtXb2LFJf7uWxsCDgdDahnbI1NKqUt0N14CsCcRYHRxVjAO7Gcp82wq6tv/qhL0QhYKd4sdD3S4jlYfp+lwLHl8AhAg+Sb3ayZNRicvHHk66uq+gEAr6TMe3qxenc8vvb3jOsrm81WDI/U3QW4WVJm7ufXYnNbW/OI2F92ar0ro7W3wNgjWZMv9OKPzbaegL8vn9bBoLAE9lqvLHlsP1KJdO4yER2RwN65fiuNkcimIYl/4thqSjKtnQXhpHjM8J6BxtYWdWAmmDXYyYx2GMAVSTc/Auxx8n9DiYw2QMBCAXAIDF8sqL61k9l4DCUz+dcAr5ok+kaMLdGg+soJzCp56g8nFRnY1hrwmvfXsVlNSaQf+4iUDICSy+BoJKT2OSaNCf4AKrcwtfOX+9UAAAAASUVORK5CYII=">-->
      <!--          </p>-->
      <!--          <p data-v-60016932="" class="set-list_item"><span data-v-60016932=""><i data-v-60016932=""-->
      <!--                      class="person-icon position-icon6"></i>{{ $t('帮助与反馈') }}</span><img data-v-60016932=""-->
      <!--                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAkCAYAAACJ8xqgAAADQUlEQVRIS52WTWgTURDH/5MNrdRaEWkRLB5EQfADQaGK1mSjRakoCBpQm4R81AhqQT140IOCXkQU9KA1aWOTViEigqIgrdnED1DwInoRehApKi0iVg22Zndk17bE9r121zm+mf+PmZ1585YAoKMnr7LBKRCYdASiIfWZef4/RolubR0xPQa4agzw3cXcFAn6Xv4XMJnR3gBYMUn8VSGXJ9ziMX2OjJIZbRBA7WQVgQYZvCEWUPudECmZzh8F8UWJaEA3ShvioaYPdqFkNSWtXWDCcYmoXymhMRxWP9uBWkBmps7uwjUGHxCJGHhTYehqKLTly0xQC2haNptVhn/VpUG8TyJ6qVeWtsb9Td+mg04AzaDTmuauH6A7AO+UiPJ68cf2eHxHUQb9BziWacXwSO1DAJvFInpYUzm4y+/3j4r8U4BmUHv7/SpldnUfGOuFUMLtmoqhvX6/X586bpLc27O9c5URdx7Aagn0RnS/N0JEXO4XZjge0Nn5pJbd+hMmLBN2n/lKa9DXZhtoBia6tXpiKgC8WJgp41wsqJ4a902b4XhQMqMtAaABqBdD+UQs6Dtv+mwBzcDrN3LLXQqZ0Cn33roboEOtAe9V20Cr/J7cGjLMVYe5gkwZjH2OgCako0vbyC56VLY/y9mfHAM707kGg6gXwBxBll8cAVPdhZU6GwUA84QlE8K2gamewlLD4GcMrhN3mo7Fgt5LtoDtXb2LFJf7uWxsCDgdDahnbI1NKqUt0N14CsCcRYHRxVjAO7Gcp82wq6tv/qhL0QhYKd4sdD3S4jlYfp+lwLHl8AhAg+Sb3ayZNRicvHHk66uq+gEAr6TMe3qxenc8vvb3jOsrm81WDI/U3QW4WVJm7ufXYnNbW/OI2F92ar0ro7W3wNgjWZMv9OKPzbaegL8vn9bBoLAE9lqvLHlsP1KJdO4yER2RwN65fiuNkcimIYl/4thqSjKtnQXhpHjM8J6BxtYWdWAmmDXYyYx2GMAVSTc/Auxx8n9DiYw2QMBCAXAIDF8sqL61k9l4DCUz+dcAr5ok+kaMLdGg+soJzCp56g8nFRnY1hrwmvfXsVlNSaQf+4iUDICSy+BoJKT2OSaNCf4AKrcwtfOX+9UAAAAASUVORK5CYII=">-->
      <!--          </p>-->
    </div>
    <div data-v-60016932="" class="set-list">
      <p data-v-60016932="" class="set-list_item" @click="$parent.outLogin">
        <span data-v-60016932="">
          <i data-v-60016932="" class="person-icon position-icon3"></i>{{ $t('退出') }}</span>
        <img data-v-60016932="" src="/static/image/new/arrow-white.png">
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'userCent',
  data() {
    return {
      checked:true,
      checked2:true,
      checked3:false,
    };
  },
  created() {
    let that = this;
  },
  methods: {
    back(){
      window.history.go(-1)
    }
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
.Setting {
  width: 100%;
  height: 100vh;
  background-color: #000;
  color: #fff;
  font-family: PingFang SC;
  background-image: url("/static/image/new/page-bg-img.png");
  background-size: cover;
}
.Setting .head_area {
  height: 1.33333rem;
  background: transparent;
  display: flex;
  justify-content: space-between;
  padding-left: 0.48rem;
  padding-right: 0.48rem;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  box-sizing: border-box;
}
.Setting .head_area .leftImg {
  flex: 1;
  text-align: left;
  font-size: .48rem;
}
.Setting .head_area .leftImg .top_back {
  width: 0.21333rem;
  height: 0.37333rem;
}
.Setting .head_area .head_text {
  font-size: 0.48rem;
  width: 45%;
  text-align: center;
}
.Setting .head_area .right_menu {
  font-size: 0.37333rem;
  font-family: PingFang SC;
  color: #424653;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: right;
}
.Setting .set-list {
  margin-top: 0.26667rem;
  box-sizing: border-box;
  padding: 0 .4rem;
}
.Setting .set-list .set-list_item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.32rem;
  font-family: PingFang SC;
  height: 1.33rem;
  line-height: 1.33rem;
  text-align: left;
  background: rgba(255, 255, 255, 0.10);
  border: 0.03rem solid rgba(255, 255, 255, 0.10);
  border-radius: .21rem;
  padding: 0 .27rem;
  margin-bottom: .27rem;
  overflow: hidden;
}
.Setting .set-list .set-list_item img {
  width: 0.4rem;
}
.Setting .set-list .set-list_item .van-switch {
  background-color: #999;
}
.Setting .set-list .set-list_item .van-switch--on {
  background: linear-gradient(to bottom, #4B5BF1 40%, #B5BBF8) !important;
  border-color: #4B5BF1 !important;

}
</style>



// WEBPACK FOOTER //
// src/components/userCent.vue